import { FormikProps, getIn } from 'formik';
import { type GetFieldCheckboxOutput } from './getFieldCheckboxProps.d';

export const getFieldCheckboxProps = <
	S extends FormikProps<{
		// eslint-disable-next-line
		[key in keyof S['values']]: any;
	}>,
>(
	formik: S,
	name: keyof S['values']
): GetFieldCheckboxOutput => {
	const { values, touched, setFieldValue, errors } = formik;

	const _onValueChange = (checked: boolean) => {
		setFieldValue(String(name), checked);
	};

	return {
		name: name as string,
		value: getIn(values, String(name)) || false,
		checked: !!(getIn(values, String(name)) || false),
		onChange: _onValueChange,
		touched: getIn(touched, String(name)),
		error: getIn(touched, String(name)) ? getIn(errors, String(name)) : '',
	};
};
